/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormFieldsFieldTypeEnum } from './FormFieldsFieldTypeEnum';
import {
    FormFieldsFieldTypeEnumFromJSON,
    FormFieldsFieldTypeEnumFromJSONTyped,
    FormFieldsFieldTypeEnumToJSON,
    FormFieldsFieldTypeEnumToJSONTyped,
} from './FormFieldsFieldTypeEnum';

/**
 * Serializer for the Fields.
 * @export
 * @interface FormFields
 */
export interface FormFields {
    /**
     * 
     * @type {string}
     * @memberof FormFields
     */
    fieldName: string;
    /**
     * 
     * @type {string}
     * @memberof FormFields
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof FormFields
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof FormFields
     */
    groupName?: string;
    /**
     * 
     * @type {FormFieldsFieldTypeEnum}
     * @memberof FormFields
     */
    fieldType?: FormFieldsFieldTypeEnum;
    /**
     * 
     * @type {any}
     * @memberof FormFields
     */
    fieldOptions?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof FormFields
     */
    isRequired?: boolean;
    /**
     * 
     * @type {any}
     * @memberof FormFields
     */
    requiredCondition?: any | null;
    /**
     * 
     * @type {any}
     * @memberof FormFields
     */
    displayWhen?: any | null;
    /**
     * 
     * @type {any}
     * @memberof FormFields
     */
    suggestionRule?: any | null;
}



/**
 * Check if a given object implements the FormFields interface.
 */
export function instanceOfFormFields(value: object): value is FormFields {
    if ((!('fieldName' in (value as Record<string, any>)) && !('field_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['fieldName'] === undefined && (value as Record<string, any>)['field_name'] === undefined)) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function FormFieldsFromJSON(json: any): FormFields {
    return FormFieldsFromJSONTyped(json, false);
}

export function FormFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormFields {
    if (json == null) {
        return json;
    }
    return {
        
        'fieldName': json['field_name'],
        'label': json['label'],
        'description': json['description'] == null ? undefined : json['description'],
        'groupName': json['group_name'] == null ? undefined : json['group_name'],
        'fieldType': json['field_type'] == null ? undefined : FormFieldsFieldTypeEnumFromJSON(json['field_type']),
        'fieldOptions': json['field_options'] === undefined ? undefined : json['field_options'] === null ? null : json['field_options'],
        'isRequired': json['is_required'] == null ? undefined : json['is_required'],
        'requiredCondition': json['required_condition'] === undefined ? undefined : json['required_condition'] === null ? null : json['required_condition'],
        'displayWhen': json['display_when'] === undefined ? undefined : json['display_when'] === null ? null : json['display_when'],
        'suggestionRule': json['suggestion_rule'] === undefined ? undefined : json['suggestion_rule'] === null ? null : json['suggestion_rule'],
    };
}

export function FormFieldsToJSON(json: any): FormFields {
    return FormFieldsToJSONTyped(json, false);
}

export function FormFieldsToJSONTyped(value?: FormFields | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field_name': value['fieldName'],
        'label': value['label'],
        'description': value['description'],
        'group_name': value['groupName'],
        'field_type': FormFieldsFieldTypeEnumToJSON(value['fieldType']),
        'field_options': value['fieldOptions'],
        'is_required': value['isRequired'],
        'required_condition': value['requiredCondition'],
        'display_when': value['displayWhen'],
        'suggestion_rule': value['suggestionRule'],
    };
}

